import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';

interface FallbackSideContainerDesktopProps {
  $alturaContainerEsquerda?: number | string;
  $alturaContainerDireita?: number | string;
  $larguraContainerEsquerda?: number | string;
  $larguraContainerDireita?: number | string;
}

export default function FallbackSideContainerDesktop(
  props: FallbackSideContainerDesktopProps,
) {
  const {
    $alturaContainerEsquerda = 215,
    $alturaContainerDireita = 215,
    $larguraContainerDireita = undefined,
    $larguraContainerEsquerda = undefined,
  } = props;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        gap: theme.spacing[6],
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          gap: theme.spacing[4],
        }}
      >
        <Skeleton
          style={{
            height: $alturaContainerEsquerda,
            width: $larguraContainerEsquerda,
            borderRadius: theme.radius[3],
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: !$larguraContainerDireita ? 1 : 0,
          gap: theme.spacing[5],
        }}
      >
        <Skeleton
          style={{
            height: $alturaContainerDireita,
            width: $larguraContainerDireita,
            borderRadius: theme.radius[3],
          }}
        />
      </div>
    </div>
  );
}
